var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.213,
    height: 17.31,
    viewBox: "0 0 15.213 17.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "user (12)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19616"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19615"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16282",
    d: "M125.564 0a4.564 4.564 0 1 0 4.564 4.564A4.569 4.569 0 0 0 125.564 0z",
    transform: "translate(-117.957)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19618"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19617"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16283",
    d: "M44.285 301.967A6.506 6.506 0 0 0 39.621 300h-2.028a6.506 6.506 0 0 0-4.664 1.967A6.652 6.652 0 0 0 31 306.66a.507.507 0 0 0 .507.507h14.2a.507.507 0 0 0 .507-.507 6.652 6.652 0 0 0-1.929-4.693z",
    transform: "translate(-31 -289.858)",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.427c641b7fbabb2a133dd44bd9b1f753.svg";
export { ForwardRef as ReactComponent };